<template>
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-row>
      <b-col>
        <b-row align-v="center" align-h="end">
          <b-col>

            <b-form-group align="left">
              <label for="nombreBusq">Fecha</label>
              <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                <b-input-group-prepend is-text>
                  <b-icon icon="menu-button-wide"></b-icon>
                </b-input-group-prepend>
                <b-form-datepicker name="nombre" placeholder="Día"
                              v-model="fecha"
                ></b-form-datepicker>
              </b-input-group>
            </b-form-group>

          </b-col>

          <b-col class="text-left">
            <b-button variant="outline-primary" @click="obtenerFacturas">Buscar</b-button>
          </b-col>

          <b-col>
          </b-col>

        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-table
            id="Pendientes"
            thead-tr-class="columnas"
            :items="datosTabla"
            :fields="fields"
            :per-page="registrosPorPagina"
            :current-page="paginaActual"
            responsive="true"
            class="parrafos"
            fixed>
          <template v-slot:cell(total)="row">
            {{ row.item.total | moneda }}
          </template>
          <template v-slot:cell(Acciones)="row">
            <b-button-group v-if="row.item.estatus.includes('xito')">
              <b-button
                  title="Cancelar factura"
                  size="sm"
                  @click="cancelarFactura(row.item)"
                  variant="outline-danger"
              ><em class="fa fa-close"></em></b-button>
              <b-button
                  title="Imprimir"
                  size="sm"
                  @click="imprimirFactura(row.item)"
                  variant="outline-info"
              >
                <em v-if="!row.item.loaderRecibo" class="fa fa-print"></em>
              </b-button>
            </b-button-group>
          </template>
        </b-table>
        <div align="center" v-if="loader">
          <b-spinner variant="primary" label="Spinning"></b-spinner>
        </div>
        <b-col v-if="!loader">
          <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
        </b-col>
        <b-col v-if="!loader">
          <b-pagination
              v-if="datosTabla !== undefined && datosTabla.length > 10"
              align="center"
              v-model="paginaActual"
              :total-rows="datosTabla.length"
              :per-page="registrosPorPagina"
              aria-controls="my-table1"
          ></b-pagination>
        </b-col>
      </b-col>


    </b-row>
</div>
</template>

<script>
import * as JSZip from "jszip";
import { saveAs } from 'file-saver'
export default {
name: "FacturasGlobales",
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [
        {key: "idFactura", label: "No.", sortable: true},
        {key: "total", label: "Total", sortable: true},
        {key: "clinica", label: "Clínica", sortable: true},
        {key: "estatus", label: "Estatus", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 15,
      paginaActual: 0,
      loader: false,
      fecha: new Date()
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerFacturas(){
      this.loader = true
      this.datosTabla = [];
      let fechaActual = this.$moment(this.fecha);
      const envio = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ")
      const parametros = {fechaStr: envio}
      this.$http.post(this.$api + 'fiscales/obtener/facturas/globales', parametros).then(respuesta => {
            if (respuesta.data.data){
              this.datosTabla = respuesta.data.data
            }
          }
      ).finally(() => {
            this.loader = false;
          }
      )
    },
    imprimirFactura(item) {
      const parametros = {idFactura: item.idFactura}
      this.$http
          .post(this.$api + "reportes/factura/erp", parametros)
          .then((respuesta) => {
            if (respuesta.data.data === null ){
             this.facturaAntigua(item)
            }else {
              window.open(respuesta.data.data);
            }
          });
    },
    facturaAntigua(item){
      this.$http.get(this.$api + 'reportes/factura?idFactura=' + item.idFactura).then(respuesta => {
        if (respuesta.data.data) {
          const datos = respuesta.data.data
          this.descargarFactura( datos)
        }
      })
    },
    descargarFactura(datos){
      const pdf =datos.pdf;
      const xml =datos.xml;
      const folio =datos.uid;
      const zip = new JSZip();
      zip.file(folio+".xml", xml, {base64: false});
      zip.file(folio+".pdf", pdf, {base64: true});
      zip.generateAsync({type:"blob"})
          .then(function(content) {
            saveAs(content, folio+".zip");
          });
    },
    cancelarFactura(item) {
      this.$http.get(this.$api + 'facturacion/cancelarFactura?idFactura=' + item.idFactura).then(respuesta => {
        if (respuesta.data.data) {
          if (respuesta.data.data === 'exito') {
            this.$swal.fire({
              icon: "info",
              title: "Aviso",
              text: "Se Canceló la factura correctamente",
            });
            this.showModalFactura = false;
            this.obtenerFacturas();
            this.cancelarCorte(item)
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: respuesta.data.data,
            });
            this.obtenerFacturas();
          }
        }
      }).catch(error => {
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: error.message,
        });
      })
    },
    cancelarCorte(item) {
      const i = new Date();
      i.setDate(i.getDate());
      i.setHours(0, 0, 0, 0);
      const inicio = this.$moment(i).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");

      const f = new Date();
      f.setHours(23, 59, 59, 999);
      const fin = this.$moment(f).utc().format("YYYY-MM-DD[T]HH:mm:ss[Z]");
      const envio = {
        idClinica : item.idClinica,
        fechaInicio: inicio,
        fechaFin: fin
      };
      this.$http.put(this.$api + 'diagnostico/cancelar/CorteCaja',envio).then(() => {
      }).catch(error => {
        console.error(error)
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "error al general el corte",
        });
      })
    },
    imprimir(item) {
      item.loaderRecibo = true;
      const envio = {
        idRecibo: item.idRecibo,
        horas: this.$horas(),
        esReciboPti: false
      }

        if ([2,7].includes(item.tipoRecibo)) {
        this.$http.post(this.$api + 'reportes/recibo', envio).then(respuesta => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data
                this.descargar('Recibo-' + item.idRecibo + new Date(), datos)
              }
            }
        ).finally(() => {
          item.loaderRecibo = false;
        })
      } else {
          envio.esReciboPti = true;
        this.$http.post(this.$api + 'reportes/recibo', envio).then(respuesta => {
              if (respuesta.data.data) {
                const datos = respuesta.data.data
                this.descargar('Recibo-' + item.idRecibo + new Date(), datos)
              }
            }
        ).finally(() => {
          this.loaderRecibo = false;
        })
      }
    },
    descargar(nombre, datos) {
      const byteCharacters = atob(datos);
      const byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      const blob = new Blob(byteArrays, {type: 'application/pdf'});

      const url = window.URL.createObjectURL(blob);
      // window.open(url);
      const link = document.createElement('a');
      link.href = url;
      link.download = nombre;
      link.click();
    },
  }
}
</script>

<style scoped>

</style>
